var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3831 7.30821L14.2485 8.85878C15.0294 10.2581 14.7159 12.0938 13.486 13.3237C13.486 13.3237 11.994 14.8156 14.699 17.5206C17.404 20.2256 18.8959 18.7337 18.8959 18.7337C20.1259 17.5037 21.9616 17.1902 23.3609 17.9712L24.9114 18.8365C27.0244 20.0157 27.274 22.979 25.4167 24.8362C24.3007 25.9522 22.9335 26.8206 21.4222 26.8779C18.878 26.9744 14.5574 26.3305 10.2233 21.9964C5.88918 17.6623 5.24529 13.3416 5.34174 10.7974C5.39904 9.28611 6.26741 7.91896 7.38342 6.80296C9.24068 4.94569 12.2039 5.19523 13.3831 7.30821Z",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.0f65dfdb062601dd83fb24d06e27bee6.svg";